import { FC } from 'react';
import classNames from 'classnames';
import { DragNDropRecExpanded } from 'components/DragNDrop/DragNDropRecExpanded';
import { SwitchToggleField } from 'components/Forms/SwitchToggleField';
import { useFieldRestrictions } from 'hooks/useFieldRestrictions';
import { IPage } from 'store/pages/types';
import { DEFAULT_OFFLINE_PAYMENT_ROWS } from './constants';
import { useFieldValue } from 'hooks/useFormHelpers';

type Props = {
  isPreviewVisible: boolean;
  editPageSelected?: IPage;
};

export const OfflineDonationForm: FC<Props> = ({ isPreviewVisible, editPageSelected }) => {
  const wireEnabled = useFieldValue('wire_enabled');
  const fieldRestrictions = useFieldRestrictions(!!editPageSelected);

  return (
    <div className="form-group">
      <span className="oath-eyebrow inkBlue">Offline donation options</span>
      <div className="row">
        <div className="margin0 form-group">
          <SwitchToggleField
            name="wire_enabled"
            label="Offline Payment Options"
            disabled={fieldRestrictions.isDisabled('wire_enabled')}
          />
        </div>
      </div>
      <div
        className={classNames('padding0', {
          'col-md-12': isPreviewVisible,
        })}
      >
        {wireEnabled && (
          <>
            <br />
            <div className="oath-utility gray">Edit each offline payment option below</div>
            <DragNDropRecExpanded
              variant="payment"
              rows={DEFAULT_OFFLINE_PAYMENT_ROWS}
              paymentSwitchDisabled={fieldRestrictions.isDisabled}
            />
          </>
        )}
      </div>
    </div>
  );
};
